import type { TenantConfig } from '@/types/TenantConfig'

export const jurassicquest: TenantConfig = {
  logo: 'assets/jurassicquest/static/logo.png',
  themeOptions: {
    dialog: {
      backgroundColor: '#F9F2E6',
      headerTextColor: 'white',
      headerIconColor: 'white',
    },
  },
  teaserImageSize: {
    height: 200,
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet:
        'https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap',
    },
    selectDate: {
      hideTodayTomorrowButtons: true,
    },
    cartWidget: {
      minHeight: '600px',
    },
  },
}
